import { Breadcrumb, Tag } from 'antd'

const CustomBreadcrumb = ({ tags }) => {
    return (
        <Breadcrumb separator={<span style={{ color: 'gray', margin: '0 2px' }}>/</span>}>

            {tags.map((tag, i) => {
                let color
                switch (tag) {
                    case 'Unprocessed':
                        color = '#FCAA16'
                        break;

                    case 'Follow Up':
                        color = '#1A99CA'

                        break;

                    case 'Campus Visit':
                        color = '#00C771'

                        break;

                    default:
                        color = '#1A99CA'
                        break;
                }

                return (
                    <Breadcrumb.Item>
                        <Tag color={color} key={tag}>
                            {tag}
                            {/* {tag.toUpperCase()} */}
                        </Tag>
                    </Breadcrumb.Item>
                );
            })}
        </Breadcrumb>
    )
}

export default CustomBreadcrumb